import t from "@emotion/styled/base";
import { Text as c } from "../../../Text/index.js";
function e() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const b = /* @__PURE__ */ t(c, process.env.NODE_ENV === "production" ? {
  target: "eqlom9j0"
} : {
  target: "eqlom9j0",
  label: "UnitText"
})(process.env.NODE_ENV === "production" ? {
  name: "1ud9i0q",
  styles: "padding:8px 0"
} : {
  name: "1ud9i0q",
  styles: "padding:8px 0/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvTnVtYmVySW5wdXQvc3ViQ29tcG9uZW50cy9Vbml0TGFiZWwvVW5pdExhYmVsLnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJb0MiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9OdW1iZXJJbnB1dC9zdWJDb21wb25lbnRzL1VuaXRMYWJlbC9Vbml0TGFiZWwuc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBUZXh0IH0gZnJvbSAnLi4vLi4vLi4vVGV4dCc7XG5cbmV4cG9ydCBjb25zdCBVbml0VGV4dCA9IHN0eWxlZChUZXh0KWBcbiAgICBwYWRkaW5nOiA4cHggMDtcbmA7XG4iXX0= */",
  toString: e
});
export {
  b as UnitText
};
